import React from 'react'
import { ReactComponent as BellIcon } from 'assets/icons/bell.svg'
import { ReactComponent as CheckCircleIcon } from 'assets/icons/check-circle.svg'
import PositionedTooltip from 'shared/components/PositionedTooltip/PositionedTooltip'
import { useAssignmentReminderCooldown } from '../../../hooks/useAssignmentReminderCooldown'
import { ASSIGNMENT_REMINDER_COOLDOWN_TOOLTIP } from '../../../utils/assignmentReminderMessages'
import s from './Assignments.module.scss'

const AssignmentReminderAction = ({
	assignmentId,
	statusKey,
	onRemind,
	cooldownRefreshKey = 0,
}) => {
	const { onCooldown } = useAssignmentReminderCooldown(
		assignmentId,
		cooldownRefreshKey,
	)

	if (statusKey === 'completed') {
		return (
			<span className={s.completedCheck} aria-hidden="true">
				<CheckCircleIcon />
			</span>
		)
	}

	const canRemind = statusKey === 'not_started' || statusKey === 'in_progress'
	if (!canRemind) {
		return <span className={s.actionPlaceholder} aria-hidden="true" />
	}

	const button = (
		<button
			type="button"
			className={`${s.bell} ${onCooldown ? s.bellDisabled : ''}`}
			disabled={onCooldown}
			aria-label={onCooldown ? 'Reminder on cooldown' : 'Send reminder'}
			onClick={event => {
				event.stopPropagation()
				if (!onCooldown) onRemind?.()
			}}
		>
			<span className={s.icon}>
				<BellIcon />
			</span>
		</button>
	)

	if (!onCooldown) return button

	return (
		<PositionedTooltip content={ASSIGNMENT_REMINDER_COOLDOWN_TOOLTIP} enabled>
			{button}
		</PositionedTooltip>
	)
}

export default AssignmentReminderAction
